import feathers from '@feathersjs/feathers'
import socketio from '@feathersjs/socketio-client'
import auth from '@feathersjs/authentication-client'
import io from 'socket.io-client'
import { iff, discard } from 'feathers-hooks-common'
import feathersVuex from 'feathers-vuex'

let socket
//const apiUrl = process.env.VUE_APP_API_URL + process.env.VUE_APP_API_PORT
// localStorage.setItem('apiUrl', apiUrl)

if (process.env.NODE_ENV === 'production') {
  socket = io('wss://ecco-api.rayoga.com', { transports: ['websocket'] })
} else {
  //socket = io('192.168.1.211:3030', { transports: ['websocket'] })
  socket = io('wss://ecco-api.rayoga.com', { transports: ['websocket'] })
}

const feathersClient = feathers()
  .configure(socketio(socket, {
    timeout: 20000
  }))
  .configure(auth({ storage: window.localStorage }))
  .hooks({
    before: {
      all: [
        iff(
          context => ['create', 'update', 'patch'].includes(context.method),
          discard('__id', '__isTemp')
        )
      ]
    }
  })

export default feathersClient

// Setting up feathers-vuex
const { makeServicePlugin, makeAuthPlugin, BaseModel, models, FeathersVuex } = feathersVuex(
  feathersClient,
  {
    serverAlias: 'api', // optional for working with multiple APIs (this is the default value)
    idField: '_id', // Must match the id field in your database table/collection
    whitelist: ['$regex', '$options']
  }
)

export { makeAuthPlugin, makeServicePlugin, BaseModel, models, FeathersVuex }
